<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height pa-6 homepage-bg">
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" sm="6" order="2" order-sm="1" class="pr-sm-4">
            <div class="d-flex justify-center justify-sm-end">
              <div class="text-center">
                <h2 class="text-h5 font-weight-medium mb-4">Selamat Datang di</h2>
                <h1 class="text-h4 font-weight-bold mb-6">Jasa Data Pratama</h1>
                <v-btn color="primary" size="large" href="/login" rounded="lg"
                  >Login ke JDP Cognito Invoice</v-btn
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" order="1" order-sm="2" class="pl-sm-4">
            <div class="d-flex justify-center justify-sm-start">
              <v-img
                src="/images/homepage.png"
                alt="JDP Cognito Invoice"
                contain
                min-width="250"
                max-width="350"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
  /* maketintsandshades.com */
  /* .v-application {
    background: #ffffff;
    background: linear-gradient(90deg, #fdfdff 0%, #f8f8fd 40%, #f2f2fc 70%, #ededfb 100%);
  } */

  .homepage-bg {
    background: #ffffff;
    background: linear-gradient(135deg, #fdfdff 0%, #f8f8fd 40%, #f2f2fc 70%, #ededfb 100%);
  }

  @media (max-width: 798px) {
    :deep(.v-btn) {
      height: auto !important;
      min-height: 60px;
    }

    :deep(.v-btn__content) {
      white-space: normal;
      word-wrap: break-word;
      text-align: center;
      line-height: 1.15;
    }
  }
</style>
